// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../../assets/images/banner/lady-three.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../../assets/images/alternative_images/curtle.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../../assets/images/alternative_images/iron.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../../assets/images/alternative_images/blender.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../../../assets/images/alternative_images/tv.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../../../assets/images/alternative_images/dryer.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.banner {
  background: transparent linear-gradient(6deg, #7062f9 0%, #8d81fa 100%) 0% 0% no-repeat padding-box;
  border-radius: 45px;
  opacity: 1;
}

.promo-section {
  padding: 0% 10% !important;
}

.shimmer-container {
  padding: 0% 10% !important;
}

.floating-btn {
  margin-left: -8%;
  margin-bottom: 2% !important;
  width: 100%;
}

.btn-glass {
  background: rgba(255, 255, 255, 0.13);
  border-radius: 16px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(5.5px);
  -webkit-backdrop-filter: blur(5.5px);
}

.banner-col-1-text {
  font-size: 50px;
}

.background-image-col-sell {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: right;
  width: 500px;
  height: 455px;
  position: absolute;
  bottom: -13%;
}

@media only screen and (max-width: 1499px) {
  .background-image-col-sell {
    bottom: -12.5% !important;
  }
}
@media only screen and (max-width: 1399px) {
  .background-image-col-sell {
    bottom: -13.5% !important;
  }
}
@media only screen and (max-width: 1359px) {
  .background-image-col-sell {
    bottom: -12.5% !important;
  }
}
@media only screen and (max-width: 1329px) {
  .background-image-col-sell {
    bottom: -12.5% !important;
  }
}
@media only screen and (max-width: 1299px) {
  .background-image-col-sell {
    bottom: -12.5% !important;
  }
}
@media only screen and (max-width: 1199px) {
  .background-image-col-sell {
    bottom: -16.5% !important;
  }
}
@media only screen and (max-width: 1130px) {
  .background-image-col-sell {
    background: none !important;
  }
  .card-on-hove-sell {
    width: 200px !important;
    height: 210px !important;
    border-radius: 30px;
    margin-top: 10% !important;
    margin-left: 20% !important;
  }
}
@media only screen and (max-width: 1099px) {
  .banner-col-1-text {
    width: 500px !important;
  }
  .card-on-hove-sell {
    margin-left: -20% !important;
  }
}
@media only screen and (max-width: 1050px) {
  .card-on-hove-sell {
    margin-left: -35% !important;
  }
}
@media only screen and (max-width: 999px) {
  .card-on-hove-sell {
    margin-left: -35% !important;
  }
  .link-section {
    display: inline !important;
  }
  .redirect-link {
    padding: 0px !important;
  }
}
@media only screen and (max-width: 950px) {
  .card-on-hove-sell {
    margin-left: -45% !important;
  }
}
@media only screen and (max-width: 899px) {
  .card-on-hove-sell {
    margin-left: -45% !important;
  }
}
@media only screen and (max-width: 850px) {
  .card-on-hove-sell {
    margin-left: -50% !important;
  }
}
@media only screen and (max-width: 774px) {
  .card-on-hove-sell {
    margin-left: 70% !important;
    margin-top: 25% !important;
  }
}
@media only screen and (max-width: 767px) {
  .banner-col-1-text {
    margin: 0% 0% !important;
  }
  .banner-text {
    font-size: 40px !important;
  }
  .banner-text-sub {
    font-weight: lighter !important;
    font-size: 15px !important;
  }
  .text-link {
    font-size: 12px !important;
    font-weight: lighter !important;
  }
}
.card-on-hove-sell {
  width: 200px;
  height: 210px;
  border-radius: 30px;
  margin-top: 10%;
}

.orange-spot {
  height: 10px;
  background: salmon;
}

.spot {
  position: absolute;
  margin-top: -10% !important;
  background: salmon;
}

.alternating-images-on-hover-sell {
  width: 220px !important;
  height: 200px !important;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  position: absolute;
  left: -20% !important;
  margin-top: -45% !important;
  animation: Swap 30s infinite;
}

@keyframes Swap {
  100% {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }
  20% {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  }
  40% {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  }
  60% {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  }
  80% {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  }
}
@media only screen and (max-width: 1399px) {
  .background-image-col-sell {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-size: contain;
    background-position: right;
    width: 500px;
    height: 455px;
    position: absolute;
    margin-top: -12% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/presentation/main/sell-with-pamo/component/banner/banner.scss"],"names":[],"mappings":"AAAA;EACE,mGAAA;EACA,mBAAA;EACA,UAAA;AACF;;AAEA;EACE,0BAAA;AACF;;AAEA;EACE,0BAAA;AACF;;AAEA;EACI,gBAAA;EAEA,4BAAA;EACA,WAAA;AAAJ;;AAGA;EACE,qCAAA;EACA,mBAAA;EACA,yCAAA;EACA,4BAAA;EACA,oCAAA;AAAF;;AAKA;EACE,eAAA;AAFF;;AAKA;EACE,yDAAA;EACD,4BAAA;EACA,wBAAA;EACA,0BAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;AAFD;;AAMA;EACE;IACC,yBAAA;EAHD;AACF;AAOA;EACE;IACE,yBAAA;EALF;AACF;AAQA;EACE;IACE,yBAAA;EANF;AACF;AAUA;EACE;IACE,yBAAA;EARF;AACF;AAWA;EACE;IACE,yBAAA;EATF;AACF;AAYA;EACE;IACE,yBAAA;EAVF;AACF;AAcA;EACE;IACC,2BAAA;EAZD;EAeA;IACE,uBAAA;IACD,wBAAA;IACA,mBAAA;IACA,0BAAA;IACA,2BAAA;EAbD;AACF;AAkBA;EACE;IACE,uBAAA;EAhBF;EAmBA;IACC,4BAAA;EAjBD;AACF;AAqBA;EAEE;IACC,4BAAA;EApBD;AACF;AAuBA;EACE;IACC,4BAAA;EArBD;EAwBC;IACC,0BAAA;EAtBF;EAyBC;IACC,uBAAA;EAvBF;AACF;AA2BA;EACE;IACC,4BAAA;EAzBD;AACF;AA6BA;EACE;IACC,4BAAA;EA3BD;AACF;AA+BA;EACE;IACC,4BAAA;EA7BD;AACF;AAiCA;EACE;IACC,2BAAA;IACA,0BAAA;EA/BD;AACF;AAkCA;EACE;IACE,wBAAA;EAhCF;EAqCA;IACE,0BAAA;EAnCF;EAuCA;IACE,+BAAA;IACA,0BAAA;EArCF;EAwCA;IACE,0BAAA;IACA,+BAAA;EAtCF;AACF;AA4CA;EACC,YAAA;EACD,aAAA;EACA,mBAAA;EACA,eAAA;AA1CA;;AA6CA;EAEC,YAAA;EACA,kBAAA;AA3CD;;AA8CA;EACC,kBAAA;EACA,2BAAA;EACA,kBAAA;AA3CD;;AA8CA;EAEE,uBAAA;EACA,wBAAA;EACA,2BAAA;EACA,wBAAA;EACA,4BAAA;EACA,kBAAA;EACA,qBAAA;EACA,2BAAA;EACA,4BAAA;AA5CF;;AA+CA;EACE;IACE,yDAAA;EA5CF;EA8CA;IACE,yDAAA;EA5CF;EA8CA;IACE,yDAAA;EA5CF;EA8CA;IACE,yDAAA;EA5CF;EA8CA;IACE,yDAAA;EA5CF;AACF;AA+CA;EAEE;IACE,yDAAA;IACD,4BAAA;IACA,wBAAA;IACA,0BAAA;IACA,YAAA;IACA,aAAA;IACA,kBAAA;IAEA,2BAAA;EA/CD;AACF","sourcesContent":[".banner {\n  background: transparent linear-gradient(6deg, #7062f9 0%, #8d81fa 100%) 0% 0% no-repeat padding-box;\n  border-radius: 45px;\n  opacity: 1;\n}\n\n.promo-section{\n  padding:0% 10% !important;\n}\n\n.shimmer-container{\n  padding:0% 10% !important;\n}\n\n.floating-btn{\n    margin-left:-8%;\n    // bottom:10px;\n    margin-bottom:2% !important;\n    width:100%;\n}\n\n.btn-glass{\n  background: rgba(255, 255, 255, 0.13);\n  border-radius: 16px;\n  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n  backdrop-filter: blur(5.5px);\n  -webkit-backdrop-filter: blur(5.5px);\n \n}\n\n\n.banner-col-1-text{\n  font-size:50px;\n}\n\n.background-image-col-sell{\n  background-image: url(\"../../../../../assets/images/banner/lady-three.png\");\n background-repeat: no-repeat;\n background-size: contain;\n background-position: right;\n width:500px;\n height:455px;\n position:absolute;\n bottom:-13%;\n\n}\n\n@media only screen and (max-width: 1499px) {\n  .background-image-col-sell{\n   bottom:-12.5% !important;\n\n  }\n}\n\n@media only screen and (max-width: 1399px) {\n  .background-image-col-sell{\n    bottom:-13.5% !important;\n  }\n}\n\n@media only screen and (max-width: 1359px) {\n  .background-image-col-sell{\n    bottom:-12.5% !important;\n  }\n}\n\n\n@media only screen and (max-width: 1329px) {\n  .background-image-col-sell{\n    bottom:-12.5% !important;\n  }\n}\n\n@media only screen and (max-width: 1299px) {\n  .background-image-col-sell{\n    bottom:-12.5% !important;\n  }\n}\n\n@media only screen and (max-width: 1199px) {\n  .background-image-col-sell{\n    bottom:-16.5% !important;\n  }\n}\n\n\n@media only screen and (max-width: 1130px) {\n  .background-image-col-sell{\n   background:none !important;\n  }\n\n  .card-on-hove-sell{\n    width: 200px !important;\n   height: 210px !important;\n   border-radius: 30px;\n   margin-top:10% !important;\n   margin-left:20% !important;\n   }\n   \n}\n\n\n@media only screen and (max-width: 1099px) {\n  .banner-col-1-text{\n    width:500px !important;\n  }\n\n  .card-on-hove-sell{\n   margin-left:-20% !important;\n   }\n}\n\n\n@media only screen and (max-width: 1050px) {\n\n  .card-on-hove-sell{\n   margin-left:-35% !important;\n   }\n}\n\n@media only screen and (max-width: 999px) {\n  .card-on-hove-sell{\n   margin-left:-35% !important;\n   }\n\n   .link-section{\n    display:inline  !important;\n   }\n\n   .redirect-link{\n    padding:0px !important;\n   }\n}\n\n\n@media only screen and (max-width: 950px) {\n  .card-on-hove-sell{\n   margin-left:-45% !important;\n   }\n}\n\n\n@media only screen and (max-width: 899px) {\n  .card-on-hove-sell{\n   margin-left:-45% !important;\n   }\n}\n\n\n@media only screen and (max-width: 850px) {\n  .card-on-hove-sell{\n   margin-left:-50% !important;\n   }\n}\n\n\n@media only screen and (max-width: 774px) {\n  .card-on-hove-sell{\n   margin-left:70% !important;\n   margin-top:25% !important;\n   }\n}\n\n@media only screen and (max-width: 767px) {\n  .banner-col-1-text{\n    margin: 0% 0% !important;\n    // font-size:50vw !important;\n\n  }\n\n  .banner-text{\n    font-size:40px !important;\n  }\n\n\n  .banner-text-sub{\n    font-weight:lighter !important;\n    font-size: 15px !important;\n  }\n  \n  .text-link{\n    font-size: 12px !important;\n    font-weight:lighter !important;\n  }\n}\n\n\n\n\n.card-on-hove-sell{\n width: 200px;\nheight: 210px;\nborder-radius: 30px;\nmargin-top:10%;\n}\n\n.orange-spot {\n // width: 10px;\n height: 10px;\n background: salmon;\n}\n\n.spot{\n position:absolute;\n margin-top:-10% !important;\n background: salmon;\n}\n\n.alternating-images-on-hover-sell {\n  // background-image: url(\"../../../../../assets/images/banner/blue-bag.png\");\n  width: 220px !important;\n  height: 200px !important;\n  background-position: center;\n  background-size: contain;\n  background-repeat: no-repeat;\n  position: absolute;\n  left: -20% !important;\n  margin-top:-45% !important;\n  animation: Swap 30s infinite;\n}\n\n@keyframes Swap {\n  100% {\n    background-image: url(\"../../../../../assets/images/alternative_images/curtle.png\");\n  }\n  20% {\n    background-image: url(\"../../../../../assets/images/alternative_images/iron.png\");\n  }\n  40% {\n    background-image: url(\"../../../../../assets/images/alternative_images/blender.png\");\n  }\n  60% {\n    background-image: url(\"../../../../../assets/images/alternative_images/tv.png\");\n  }\n  80% {\n    background-image: url(\"../../../../../assets/images/alternative_images/dryer.png\");\n  }\n}\n\n@media only screen and (max-width: 1399px) {\n  \n  .background-image-col-sell{\n    background-image: url(\"../../../../../assets/images/banner/lady-three.png\");\n   background-repeat: no-repeat;\n   background-size: contain;\n   background-position: right;\n   width:500px;\n   height:455px;\n   position:absolute;\n  //  margin-left:20%;\n   margin-top:-12% !important;\n  \n   // position:absolute;\n  }\n  }\n\n  // @media only screen and (max-width: 1199px) {\n  \n  //   .background-image-col-sell{\n  //     background-image: url(\"../../../../../assets/images/banner/lady-three.png\");\n  //    background-repeat: no-repeat;\n  //    background-size: contain;\n  //    background-position: right;\n  //    width:400px;\n  //    height:355px;\n  //    position:absolute;\n    //  margin-left:20%;\n     \n    \n     // position:absolute;\n    // }\n\n    // .card-on-hove-sell{\n    //   width: 200px;\n    //  height: 210px;\n    //  border-radius: 30px;\n    //  margin-top:10%;\n    //  margin-left:-10%;\n    //  }\n     \n\n\n    // }\n  \n\n    // @media only screen and (max-width: 991px) {\n  \n    //   .background-image-col-sell{\n    //     background-image:none !important;\n    //   }\n  \n    //   .card-on-hove-sell{\n    //     width: 200px;\n    //    height: 210px;\n    //    border-radius: 30px;\n    //    margin-top:10%;\n    //    margin-left:3%;\n    //    }\n       \n    //    .btn-section-sell{\n    //     display: inline !important;\n    //    }\n\n    //    .get-the-app-btn{\n    //     margin:10px 0px !important;\n    //    }\n  \n  \n    //   }\n    \n    \n    \n "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
